/*eslint-disable*/

export const UPGRADE_AUTHOR = "UPGRADE_AUTHOR";
export const UPGRADE_DELETE_AUTHOR = "UPGRADE_DELETE_AUTHOR";
export const UPGRADE_EDIT_AUTHOR = "UPGRADE_EDIT_AUTHOR";

export const UPGRADE_PRODUCT = "UPGRADE_PRODUCT";
export const UPGRADE_DELETE_PRODUCT = "UPGRADE_DELETE_PRODUCT";
export const UPGRADE_EDIT_PRODUCT = "UPGRADE_EDIT_PRODUCT";

export const UPGRADE_CATEGORY = "UPGRADE_CATEGORY";
export const UPGRADE_DELETE_CATEGORY = "UPGRADE_DELETE_CATEGORY";
export const UPGRADE_EDIT_CATEGORY = "UPGRADE_EDIT_CATEGORY";

export const UPGRADE_USER = "UPGRADE_USER";
export const UPGRADE_DELETE_USER = "UPGRADE_DELETE_USER";
export const UPGRADE_EDIT_USER = "UPGRADE_EDIT_USER";
